<template>
  <div>
    <template v-if="theme && theme === 'white'">
      <div id="topHeader" :style="[{'background': scrollTop > 0 ? 'rgba(0, 0, 0, 0.95)' : 'rgba(0, 0, 0, 0)'}]" class="topHeader" @mouseover="headerMouseenter1">
        <div class="topLogo">
          <img src="../assets/images/logo_s@4x.png" class="logo" @click="goHome">
          <!-- <img src="../assets/images/cqtLogo.png" class="logo" @click="goHome"> -->
          <div class="disflex ali_cen" v-if="username">
            <div class="contral" @click="goConsole">控制台</div>
            <div @click="dialogVisible = true"
              :style="[{'box-shadow': flag ? '-6px 2px 17px 0px rgba(87,138,255,0.1)' : ''}]"
              style="width: 116px;height: 45px;cursor: pointer;padding: 0 5px;border-radius: 10px;display: flex;justify-content: center;align-items: center;padding: 0 10px;box-sizing: border-box;">
              <img :src="avatarPath ? baseUrl + avatarPath : defautAvatar" style="width: 26px;height: 26px; margin-right: 8px;border-radius: 50%;" alt="">
              <div style="font-size: 18px;font-family: PingFang SC;font-weight: 500; color: #fff;">{{username}}
              </div>
            </div>
          </div>
          <div v-else
            style="width: 95px;height: 47px;background: #0F5EFF;border-radius: 10px;text-align: center;line-height: 47px;color: #fff;margin: 0 10px;cursor: pointer;"
            @click="toLogin">
            登录/注册
          </div>
        </div>

        <div id="trigger" style="display: flex;justify-content: space-between;align-items: center;width: 95%;">
          <div class="navItemBox" v-for="(item, index) in titleList" :key="index" style="position: relative;" @mouseenter='ptIndex = index' @onmouseleave="ptIndex = index"
            :class="'navItemBox'+index">
            <div class="titleName" @click="handleScroll(item.id, index)">
              <div class="navItem">
                {{item.name}}
              </div>
              <img v-if="item.children" src="../assets/images/logo_q@4x.png" class="jtImg" alt="">
            </div>
          </div>
        </div>

        <el-dialog title="提示" :append-to-body="true" :visible.sync="dialogVisible" width="30%">
          <span>确定要退出该账号吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="setLogin">确 定</el-button>
          </span>
        </el-dialog>

      </div>
    </template>
    <template v-else>
      <!-- <div
        :style="[{'background' : flag  ? 'rgba(5, 3, 21, 0.95)' : 'rgba(28, 38, 51, 0)'}, {'box-shadow': flag ? '-6px 2px 17px 0px rgba(87,138,255,0.1)' : ''}]"
        style="" class="topHeader" @mouseover="headerMouseenter" @mouseout="headerMouseleave"> -->
        <div id="topHeader" style="background: rgba(0, 0, 0, 0.95)" class="topHeader" @mouseover="headerMouseenter" @mouseout="headerMouseleave">
        <div class="topLogo">
          <img src="../assets/images/logo_s@4x.png" class="logo" @click="goHome">
          <!-- <img src="../assets/images/cqtLogo.png" class="logo" @click="goHome"> -->
           <!-- <span style="color: #f00;">{{ flag }}</span> -->
          <div class="disflex ali_cen" v-if="username">
            <div class="contral" @click="goConsole">控制台</div>
            <div @click="dialogVisible = true"
              :style="[{'box-shadow': flag ? '-6px 2px 17px 0px rgba(87,138,255,0.1)' : ''}]"
              style="width: 116px;height: 45px;cursor: pointer;padding: 0 5px;border-radius: 10px;display: flex;justify-content: center;align-items: center;padding: 0 10px;box-sizing: border-box;">
              <img :src="avatarPath ? baseUrl + avatarPath : defautAvatar" style="width: 26px;height: 26px; margin-right: 8px;border-radius: 50%;" alt="">
              <div style="font-size: 18px;font-family: PingFang SC;font-weight: 500; color: #fff;">{{username}}
              </div>
            </div>
          </div>
          <div v-else
            style="width: 95px;height: 47px;background: #0F5EFF;border-radius: 10px;text-align: center;line-height: 47px;color: #fff;margin: 0 10px;cursor: pointer;"
            @click="toLogin">
            登录/注册
          </div>
        </div>
        <div id="trigger" style="display: flex;justify-content: space-between;align-items: center;width: 95%;">
          <div class="navItemBox" v-for="(item, index) in titleList" :key="index" style="position: relative;" @mouseenter='ptIndex = index' @onmouseleave="ptIndex = index"
            :class="'navItemBox'+index">
            <div class="titleName" @click="handleScroll(item.id, index)">
              <div class="navItem">
                {{item.name}}
              </div>
              <img v-if="item.children" src="../assets/images/jt.png" class="jtImg" alt="">
            </div>
          </div>
        </div>

        <el-dialog title="提示" :append-to-body="true" :visible.sync="dialogVisible" width="30%">
          <span>确定要退出该账号吗？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="setLogin">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </template>
     <!--二级菜单 start-->
      <div id="subMenuContent" class="subMenuContent" :class="'subMenuContent'+ptIndex" v-if="ptIndex && subMenuData.length" @mouseenter="handleSubMenuMousemove" @mouseleave="handleSubMenuMouseout">
        <div class="leftMenu">
          <template v-if="ptIndex == 2">
            <span @click="toSolutionList">查看全部解决方案>></span>
          </template>
          <template v-if="ptIndex == 3">
            <span @click="goMoreApp">查看全部应用>></span>
          </template>
          <template v-if="ptIndex == 6">
            <span class="ts">标识解析</span>
          </template>
        </div>

        <div class="rightMenu">
          <div class="subMenuItem" v-for="(subItem, idx) in subMenuData" :key="subItem.topTitle" @mouseenter="subIndex = idx" @click.stop="toDetails(subItem.id, subItem.path)">
            <template v-if="ptIndex == 6">
                <template v-if="idx === subIndex">
                <img :src="subItem.selectIcon" />
                </template>
                <template v-else>
                <img :src="subItem.icon" />
                </template>
            </template>
            <template v-else>
                <template v-if="idx === subIndex">
                <img :src="baseUrl + subItem.selectIcon" />
                </template>
                <template v-else>
                <img :src="baseUrl + subItem.icon" />
                </template>
            </template>

             {{subItem.topTitle}}
          </div>
        </div>

      </div>
     <!--二级菜单 end-->
  </div>

</template>
<script>
import {
  serverUrl
} from '@/utils/server.js'
import {
  getStatus,
  getLogout,
  getJJFAData,
  getApplicationData,
  fetchWebsiteInfo
} from '@/api/api'
import request from '../utils/request'
export default {
  data () {
    return {
      scrollTop: 0,
      ptIndex: null,
      subIndex: null,
      defautAvatar: require('../assets/images/-s-mrtx.png'),
      baseUrl: serverUrl.baseURL,
      avatarPath: '',
      websiteInfo: null,
      itemList: [],
      scroll: 'home',
      dialogVisible: false,
      itemVal: {},
      dynamicActive: 0,
      dynamicItem: [{
        time: '09/09',
        date: '2021',
        data: '2021-09-09 09:42:23',
        title: '重磅：工业互联网标识服务进入牌照时代',
        img: '',
        content: '日前，工业和信息化部为中国信息通信研究院工业互联网标识解析国家顶级节点发放首张工业互联网标识服务许可证，这是自《工业互联网标识管理办法》发布以来发放的首张许可证。同时，工联网记者从消息人士处获悉：监管部门将向符合资质的工业互联网标识解析二级节点陆续发放标识服务许可证，这意味着，我国工业互联网标识服务正式进入牌照时代。'
      }, {
        time: '03/16',
        date: '2021',
        data: '2021-03-16 19:20:54',
        title: '三次提到工业互联网：“十四五”规划纲要说了啥？',
        content: '3月11日，十三届全国人大四次会议表决通过了关于国民经济和社会发展第十四个五年规划和2035年远景目标纲要的决议，决定批准这个规划纲要。规划纲要全文共19篇65章，是指导我国今后5年及15年国民经济和社会发展的纲领性文件，备受全民关注。'
      }, {
        time: '12/31',
        date: '2021',
        data: '2020-12-31 02:12:50',
        title: '技术与标准丨基于UICC的工业互联网标识多维数据融合研究',
        content: '工业数据融合是打破信息孤岛、实现数据互通和信息共享的重要抓手，工业互联网标识可作为不同企业间进行数据关联和融合的重要媒介，通过将工业互联网标识写入UICC卡中，赋能工业终端广域联网能力。基于UICC的工业互联网标识多维数据融合模型，旨在推动传统工业企业向以工业互联为基础的智能制造业转变，实现企业间的数据融合和信息共享。'
      }, {
        time: '06/09',
        date: '2020',
        data: '2020-06-09 14:23:52',
        title: '移动互联网应用IPv6网络兼容性测试云平台即将上线',
        content: '当前，随着5G、工业互联网等新技术的持续演进，万物互联已成为未来网络发展的主要方向。由于IPv4地址资源短缺、网络拓扑结构复杂、安全隐患等问题日益凸显，以IPv6为代表的下一代互联网技术应运而生。发展IPv6网络，不仅是互联网演进升级的必然趋势，更是助力互联网与实体经济深度融合、支撑经济高质量发展的迫切需要，促进生产生活数字化、网络化、智能化发展的关键要素。'
      }],
      flag: false,
      activeIndex: 1,
      username: '',
      activeSC: 1,
      activeName: '1',
      policyList: [{
        title: '山西省人民政府关于深化...',
        content: '到2025年，力争培育形成1-2个具有行业竞争力的行业工业互联网平台。推动1000家工业企业依托工业互联网平台实施数字化、网络化改造,形成一批具有示范引领作用的制造业新模式。落户1个公共标...',
        time: '2022-11-07 18:21:56'
      },
      {
        title: '《山西省工业互联网创新发...',
        content: '加快完善工业互联网网络体系建设，促进平台发展，加快提升企业工业互联网意识和能力，新型基础设施进一步完善。初步建成覆盖14大战略性新兴产业集群的工业互联网网络基础设施。',
        time: '2022-11-07 18:21:56'
      },
      {
        title: '《山西省国民经济和社会发展...',
        content: '加快建设工业互联网,构建覆盖全省重点工业区域的工业互联网体系。围绕先进制造升级等领域，推进国家级互联网骨干直联点建设,打造一批国家级、省级工业互联网行业级平台，拓展标识解析应用场景。',
        time: '2022-11-07 18:21:56'
      }
      ],
      active: 1,
      val: '',
      finalList: [{
        name: '碳效码',
        content: '实现工业企业碳效查询“一码了然”'
      }, {
        name: '唐久码',
        content: '为酒企定制了数字化全链路营销方案及工具'
      }, {
        name: '日化标识码',
        content: '沉淀私域流量、裂变营销获客必备神器'
      }],
      titleList: [{
        name: '首页',
        id: 'home'
      },
      {
        name: '政策资讯',
        id: 'zcInformation'
      },
        // {
        //   name: '政策支持',
        //   id: 'support'
        // },
        // {
        //   name: '工业资讯',
        //   id: 'information'
        // },
      {
        name: '解决方案',
        id: 'solution',
        children: [{
          name: '产品溯源管理',
          path: ''
        }, {
          name: '车辆物流管理',
          path: ''
        }, {
          name: '防窜货管理',
          path: ''
        }, {
          name: '防伪系统管理',
          path: ''
        }, {
          name: '供应链管理',
          path: ''
        }, {
          name: '智能产品全生命周期管理',
          path: ''
        }, {
          name: '人员生产安全',
          path: ''
        }, {
          name: '设备预测性运维',
          path: ''
        }, {
          name: '设备状态监测',
          path: ''
        }, {
          name: '设备资产管理',
          path: ''
        }]
      },
      {
        name: '应用市场',
        id: 'market',
        children: [{
          topTitle: '码客通',
          path: '/marketdetails'
        }, {
          topTitle: '多码合一'
        }, {
          topTitle: '任意贴'
        }, {
          topTitle: '防伪'
        }, {
          topTitle: '防窜货'
        }, {
          topTitle: '易客展示屏'
        }, {
          topTitle: '智慧瓶盖'
        }]
      },
      {
        name: 'IOT平台',
        id: 'iot'
      },
      {
        name: '供需平台',
        id: 'platform'
      },
      {
        name: '标识解析',
        id: 'node',
        children: [
          {
            topTitle: '二级节点',
            path: '/SecondaryNode',
            icon: require('../assets/images/qsjc1@2x.png'),
            selectIcon: require('../assets/images/qsjc2@2x.png')
          },
          {
            topTitle: '企业节点',
            path: '/CompanyNode',
            icon: require('../assets/images/sjd1@2x.png'),
            selectIcon: require('../assets/images/sjd2@2x.png')
          }
          // {
          //   topTitle: '标识应用',
          //   path: '/Guidance',
          //   icon: require('../assets/images/jszd1@2x.png'),
          //   selectIcon: require('../assets/images/jszd2@2x.png')
          // },
          // {
          //   topTitle: '建设咨询',
          //   path: '/build',
          //   icon: require('../assets/images/jszx1@2x.png'),
          //   selectIcon: require('../assets/images/jszx2@2x.png')
          // }, {
          //   topTitle: '运营管理',
          //   path: '/operation',
          //   icon: require('../assets/images/yygl1@2x.png'),
          //   selectIcon: require('../assets/images/yygl2@2x.png')
          // },

        ]
      },
      {
        name: '数据服务',
        id: 'data'
      },
      {
        name: '人才服务',
        id: 'talent'
      },
      {
        name: '信息安全',
        id: 'safe'
      },
      {
        name: '开放服务',
        id: 'open'
      },
      {
        name: '供应链金融',
        id: 'finance'
      },
      {
        name: '法律服务',
        id: 'internet'
      },
      {
        name: '生态与合作',
        id: 'ecology'
      }
      ],
      subMenuData: [],
      // defaultFlag: null
    }
  },
  props: ['theme'],
  watch: {
    '$route' (to, from) {
      this.$router.go(0)
    },
    'ptIndex' () {
      if (this.titleList[this.ptIndex].children) {
        this.subMenuData = this.titleList[this.ptIndex].children
      } else {
        this.subMenuData = []
      }
    }
  },
  created () {
    this.getYYData()
    this.setJJFAData()
    this.getWebsiteInfo()
    if (this.$route.query.id) {
      var that = this
      this.$nextTick(() => {
        that.handleScroll(this.$route.query.id)
      })
    }

    window.addEventListener('scroll', this.handleScroll1)
    this.itemVal = this.dynamicItem[0]
  },
  mounted(){
    console.log('执行这里了')
    this.getUserInfo()
    console.log('................',this.theme)
    const target = document.getElementById('topHeader');
    const trigger = document.getElementById('subMenuContent');

    target.addEventListener('mouseover', function() {
      this.theme = '123'
    });
  },
  methods: {
    getUserInfo () {
      let user = localStorage.getItem('user')
      if (!user) {
        request({
          url: '/website/auth/userInfo'
        }).then(res => {
          localStorage.setItem('user', JSON.stringify(res.data))
          this.username=res.data.username
          this.avatarPath = res.data.avatarPath
        })
      }else {
        user=JSON.parse(user)
        if (user && user.username) {
          this.username = user.username
          this.avatarPath = user.avatarPath
        }
      }
    },
    goMoreApp () {
      this.$router.push({
        path: '/appList'
      })
    },
    toSolutionList () {
      this.$router.push({
        path: '/SolutionList'
      })
    },
    headerMouseenter () {
      this.flag = true
      // this.defaultFlag = this.flag
      // if (!this.flag) {
      //   this.flag = true
      // }
    },
    headerMouseenter1 () {
      this.theme = '123'
      // this.defaultFlag = this.flag
      // if (!this.flag) {
      //   this.flag = true
      // }
    },
    headerMouseleave () {
      var scrollT = document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollT === 0) {
        if(!this.titleList[this.ptIndex].children) {
          this.flag = false
        }
      }
      // this.flag = false
      // this.flag = this.defaultFlag
    },
    handleSubItemMouseout () {
      this.subIndex = null
    },
    handleSubMenuMousemove () {

      // this.defaultFlag = this.flag
      // if (!this.flag) {
      //   this.flag = true
      // }
    },
    handleSubMenuMouseout () {
      // this.flag = this.defaultFlag
      this.ptIndex = null
      var scrollT = document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollT === 0) {
        this.flag = false
      }

      const target = document.getElementById('topHeader');

      console.log(this.$route.path)
      if(this.$route.path == '/home') {
        this.theme = 'white'
      }else [
        this.theme = '123'
      ]
    },
    goHome () {
      this.$router.push({
        path: '/home'
      })
    },
    getWebsiteInfo () {
      fetchWebsiteInfo().then(res => {
        // todo
        this.websiteInfo = res.data
      })
    },
    getYYData () {
      let params = {
        page: 0,
        size: 100
      }
      getApplicationData(params).then(res => {
        // this.titleList[4].children = res.data.content
        res.data.content.map((item, index) => {
          this.$set(this.titleList[3].children, [index], {
            'topTitle': item.title,
            'id': item.id,
            'icon': item.icon,
            'selectIcon': item.selectIcon
          })
        })
      })
    },
    setJJFAData () {
      let params = {
        type: 1
      }
      getJJFAData(params).then(res => {
        this.titleList[2].children = res.data.content
      })
    },
    getDynamic (val, item) {
      this.dynamicActive = val
      this.itemVal = item
    },
    toDetails (val, path) {
      let index = this.ptIndex
      if (index == 2) {
        this.$router.push({
          path: '/DetailsPage',
          query: {
            data: val
          }
        })
      } else if (index == 3) {
        this.$router.push({
          path: '/marketdetails',
          query: {
            data: val
          }
        })
      } else if (index == 6) {
        this.$router.push({
          path: path
        })
      }
    },
    mouseOver (item) {
      if (item) {
        this.itemList = item
      }
      console.log(JSON.stringify(item.children))
    },
    handleScroll1 () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
      console.log(this.scrollTop)
      if (scrollTop > 0) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    // 全省监测
    goDetail (data) {
      this.$router.push({
        path: data.path
      })
    },
    goDP () {
      getStatus().then(res => {
        if (parseInt(res.status) === 1) {
          window.open('http://platform.iiasx.org.cn/dps', '_blank')
        } else {
          // this.$router.push({
          //   path: '/login'
          // })
          // location.href = '/oauth2/authorization/platform'
        }
      })
    },
    goConsole () {
      this.$router.push({
        path: '/MyApp'
      })
    },
    toLogin () {
      this.$router.push({
        path: '/platlogin'
      })
    },
    setLogin () {
      getLogout().then(res => {
        localStorage.removeItem('user')
        this.$router.push({
          path: '/platlogin'
        })
      }).catch(err => {
        localStorage.removeItem('user')
        this.$router.push({
          path: '/platlogin'
        })
      })
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    tap (val) {
      this.active = val
    },
    tabNode (val) {
      console.log(val)
      this.activeIndex = val
    },
    handleScroll (id, index) {
      // this.activeIndex = index
      var element = document.getElementById(id)
      if (!element) {
        this.$router.push({
          path: '/home',
          query: {
            id: id
          }
        })
      }
      this.scroll = element.id
      this.$emit('setScroll', this.scroll)
      // console.log('==========' + this.scroll)
      // console.log('111', this.$refs.support.getBoundingClientRect().top)
      // element.scrollIntoView({
      //   behavior: "smooth",
      //   block: "center",
      //   inline: "nearest"
      // })
    }
  }
}
</script>
<style scoped>
  .banner {
    width: 100%;
    height: 1080px;
    background: url('../assets/images/banner@2x.png') top left no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    position: relative;
    /* flex-direction: column; */
  }

  .titleName {
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin: 0 10px; */
    cursor: pointer;
    padding: 10px 5px 0;
  }

  .page {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
  }

  /* ::-webkit-scrollbar {
    display: none !important;
  } */

  .bs_bj {
    width: 1373px;
    height: 240px;
    background: url('../assets/images/bs_bj@2x.png') top left no-repeat;
    background-size: cover;
    text-align: center;
  }

  /deep/ .el-input__inner {
    width: 1213px;
    height: 64px;
    border: 1px solid #C4CFDE;
    border-radius: 32px;
    text-align: center;
  }

  /deep/ input::-webkit-input-placeholder {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #97A9C7;
  }

  /deep/ input::-moz-placeholder {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #97A9C7;
  }

  /deep/ input:-ms-input-placeholder {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #97A9C7;
  }

  .marketList>div {
    cursor: pointer;
  }

  .final {
    position: relative;
    width: 100%;
    height: 840px;
    /* background: url('../assets/images/final@2x.png') top left no-repeat;
    background-size: 50% 100%; */
    padding: 88px 0;
    box-sizing: border-box;
  }

  .platform {
    width: 100%;
    height: 740px;
    box-sizing: border-box;
    /* background: #010513; */
    background: url('../assets/images/gx_bj@2x.png') top left no-repeat;
    background-size: cover;
    padding: 88px 0;
  }

  .finance {
    width: 100%;
    height: 745px;
    box-sizing: border-box;
    background: linear-gradient(183deg, #F0F6FF, #FFFFFF);
    padding: 88px 0;
  }

  .policy {
    width: 100%;
    height: 775px;
    box-sizing: border-box;
    background: url('../assets/images/zcbj@2x.png') top left no-repeat;
    background-size: cover;
    padding: 88px 0;
  }

  .one,
  .two,
  .three {
    width: 919px;
    height: 500px;
    display: flex;
    align-items: center;
    padding: 0 76px;
    /* flex-direction: column; */
  }

  .one {
    box-sizing: border-box;
    background: url('../assets/images/txm@2x.png') top left no-repeat;
    background-size: cover;
  }

  .two {
    box-sizing: border-box;
    background: url('../assets/images/tjm_bj@2x.png') top left no-repeat;
    background-size: cover;
  }

  .three {
    box-sizing: border-box;
    background: url('../assets/images/rhm_t@2x.png') top left no-repeat;
    background-size: cover;
  }

  .one .content,
  .two .content,
  .three .content {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 26px;
    margin: 52px 0 27px;
    width: 765px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .line {
    margin: 40px auto 0;
    width: 1214px;
    height: 12px;
    /* background: url('../assets/images/jt@2x.png') top left no-repeat; */
    background-image: linear-gradient(to right, #DFE9FF 5%, #53A6FF 99%, #DFE9FF);
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    position: relative;
  }

  .policy .content {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
  }

  .policy .item:hover {
    background-color: #fff !important;
  }

  .policy .item:hover .trangle {
    position: absolute;
    bottom: -10px;
    left: 170px;
    width: 0;
    height: 0;
    border-top: 10px solid #fff !important;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
  }

  .dynamic {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    background: url('../assets/images/dtbj@2x.png') top left no-repeat;
    background-size: cover;
    padding: 88px 0;
  }

  .dynamicLeft {
    width: 475px;
    height: 547px;
    box-sizing: border-box;
    background: url('../assets/images/dt@2x.png') top left no-repeat;
    background-size: cover;
    padding: 30px;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background-color: #fff
  }

  /deep/ .el-tabs__item {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #121E30;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #0478ED;
  }

  .dynamicActive1 {
    background: #FFFFFF;
    box-shadow: 6px 6px 16px 0px #EAEDF2;
    border-radius: 10px;
  }

  .service {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    background: url('../assets/images/kffw_bj@2x.png') top left no-repeat;
    background-size: cover;
    padding: 88px 0;
  }

  .Internet {
    width: 100%;
    height: 734px;
    box-sizing: border-box;
    background: url('../assets/images/ny_bj@2x.png') top left no-repeat;
    background-size: cover;
    padding: 88px 0;
  }

  .about .name {
    cursor: pointer;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #A0AEC1;
    line-height: 36px;
  }

  .scOne:hover,
  .scTwo:hover,
  .scThree:hover,
  .scFour:hover,
  .scFive:hover,
  .scSix:hover,
  .scSeven:hover {
    background: #0D65FF !important;
  }

  .scOne:hover .content,
  .scOne:hover .content,
  .scTwo:hover .content,
  .scThree:hover .content,
  .scFour:hover .content,
  .scFive:hover .content,
  .scSix:hover .content,
  .scSeven:hover .content {
    color: #9ABFFF !important;
  }

  .scOne:hover .left {
    top: 85px !important;
    left: 105px !important;

  }

  .scOne:hover .right {
    top: 70px;
    left: 140px !important;
  }

  .scTwo:hover .left,
  .scTwo:hover .left,
  .scThree:hover .left,
  .scFour:hover .left,
  .scFive:hover .left,
  .scSix:hover .left,
  .scSeven:hover .left {
    top: 60px !important;
    left: 105px !important;
  }

  .scTwo:hover .right,
  .scTwo:hover .right,
  .scThree:hover .right,
  .scFour:hover .right,
  .scFive:hover .right,
  .scSix:hover .right,
  .scSeven:hover .right {
    top: 30px;
    left: 140px !important;
  }

  .trangle {
    position: absolute;
    bottom: -10px;
    left: 170px;
    width: 0;
    height: 0;
    border-top: 10px solid #ECF2FF;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
  }

  /* .item11, .item22 {
    width: 240px;
    display: none !important;
  }

  .item1:hover  .item11{
    display: block !important;
  }

  .item2:hover  .item22{
    display: block !important;
  }

  .item3:hover  .item33{
    display: block !important;
  }

  .item11 > div , .item22 >div {
    width: 80px;
  }

  .item33 {
    width: 480px;
    display: none !important;
  }

  .item33 > div {
    width: 200px;
  } */
  /***/
  .topLogo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 17px;
  }

  .topLogo .logo {
    /* width: 317px; */
    height: 45px;
    cursor: pointer;
  }

  .navItem {
    font-size: 16px;
    font-family: PingFang SC;
    position: relative;
    color: #fff;
  }

  .subBox {
    position: absolute;
    left: 0;
    right: 0;
    top: 40px;
    /* background: #fff;
    line-height: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    border-radius: 5px;
    position: absolute;
    width: 310px;
    top: 40px;
    display: none; */
  }

  .subItem {
    /* padding: 10px 20px;
    display: inline-block;
    font-size: 14px;
    width: 50%;
    box-sizing: border-box; */
  }

  .topHeader {
    align-items: center;
    width: 100%;
    position: fixed;
    top: 0px;
    padding: 0 60px;
    box-sizing: border-box;
    z-index: 999;
  }
/*
  .topHeader:hover {
    background: rgba(0, 0, 0, 0.95) !important;
  } */

  .navItemBox {
    padding-bottom: 15px;
  }

  .navItemBox:hover .subBox {
    display: block;
  }

  /* .navItemBox3 .subBox {
    width: 400px;
  }

  .navItemBox4 .subBox {
    width: 220px;
  }

  .navItemBox6 .subBox {
    width: 220px;
  } */

  .subItem:hover {
    color: rgb(12, 103, 216);
    cursor: pointer;
  }

  .jtImg {
    width: 8px;
    height: 4px;
    margin-left: 5px;
    margin-top: 3px;
    transition: all linear 0.3s;
  }

  .navItemBox:hover .jtImg {
    transform: rotate(180deg);
  }

  .disflex {
    display: flex;
  }

  .ali_cen {
    align-items: center;
  }

  .contral {
    color: #fff;
    position: relative;
    padding-right: 10px;
    cursor: pointer;
  }

  .contral::after {
    width: 1px;
    height: 25px;
    display: block;
    content: "";
    position: absolute;
    background: #fff;
    right: -10px;
    top: 0px;
  }

  .contral a {
    color: #fff;
  }

  .contral2 {
    color: #1C2633;

  }

  .contral2 a {
    color: #1C2633;
  }

  .navItem2 {
    color: #1C2633;
  }

  .name {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #fff;
  }

  .name2 {
    color: #1C2633;
  }

  .contral2::after {
    background: #1C2633;
  }

  /**二级菜单**/
  .subMenuContent{
    position: fixed;
    top: 109px;
    left: 0;
    right: 0;
    height: 130px;
    z-index: 999;
    box-sizing: border-box;
    /* background: rgba(5, 3, 21, 1); */
    /* padding: 0 60px; */
    display: flex;
    justify-content: flex-start;
    align-self: center;
  }
  .subMenuContent3 .leftMenu{
    background-image: url('../assets/images/subMenuBg1.png');
  }
  .subMenuContent4 .leftMenu{
    background-image: url('../assets/images/subMenuBg2.png');
  }
  .subMenuContent6 .leftMenu{
    background-image: url('../assets/images/subMenuBg3.png');
  }
  .leftMenu{
    padding-left: 60px;
    width: 11%;
    background-color: rgba(13, 13, 38, 0.95);
    padding-top: 30px;
    padding-right: 40px;
    text-align: right;
    background-image: url('../assets/images/subMenuBg1.png');
    background-position: left bottom;
    background-repeat: no-repeat;
    background-size: 139px 109px;
  }
  .leftMenu span{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
  }
  .leftMenu span.ts{
    position: relative;
    top: 25px;
  }
  .rightMenu{
    flex: 1;
    background: rgba(5, 3, 21, 0.95);
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0;
  }
  .subMenuItem{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 50px;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    float: left;
    width: 20%;
    box-sizing: border-box;
  }
  .subMenuItem img{
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }
  .subMenuItem:hover{
    color: rgba(16, 224, 255, 1);
  }
  .leftMenu span:hover{
    color: rgba(16, 224, 255, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue